import { gql } from "@apollo/client";

export const newTaskInLibrary = gql`
    mutation($input: TaskLibraryInput!){
        newTaskInLibrary(input: $input) {
            message
            response
        }
    }
`;

export const updateTaskInLibrary = gql`
mutation($input: TaskLibraryInput!){
  updateTaskInLibrary(input: $input) {
    message
    response
  }
}
`;

export const archiveTaskInLibraryMutation = gql`
mutation($isArchived: Boolean!, $id: String!){
  toggleArchiveTaskInLibrary(isArchived: $isArchived, _id: $id) {
    message
    response
  }
}
`;